import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@chilecompra/react-kit/components'
import { Action, Divider, Grid } from './QuoteStepTwo.styles'

/**
 * The SellersAdded's component.
 */
const SellersAdded = props => {
  const { divider, dni, margin, businessName, onRemoveSeller } = props
  const handleDeleteSeller = () => onRemoveSeller({ dni })

  return (
    <>
      <Grid container margin={margin}>
        <Grid item xs={12} sm={3}>
          <Typography color="black1" fontSize="14px" lineHeight="28px" variant="body2">
            {dni}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={7}>
          <Typography color="black1" fontSize="14px" lineHeight="28px" variant="body2">
            {businessName}
          </Typography>
        </Grid>
        <Grid item xs={12} sm>
          <Action color="blue" onClick={handleDeleteSeller}>
            Eliminar
          </Action>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs>
          {divider && <Divider />}
        </Grid>
      </Grid>
    </>
  )
}

SellersAdded.defaultProps = {
  margin: '8px 0',
  onRemoveSeller: () => undefined
}

SellersAdded.propTypes = {
  businessName: PropTypes.string.isRequired,
  divider: PropTypes.bool.isRequired,
  dni: PropTypes.string.isRequired,
  margin: PropTypes.string,
  onRemoveSeller: PropTypes.func
}

export default SellersAdded
